/** Origin storage usage ratio at or above which the Sync storage tab shows a warning. */
export const SYNC_STORAGE_QUOTA_WARN_RATIO = 0.8;

/** Blocks new media saves when projected usage crosses this ratio. */
export const SYNC_STORAGE_QUOTA_BLOCK_RATIO = 0.95;

export const STORAGE_QUOTA_BLOCK_MESSAGE_ES =
  'No hay espacio suficiente en el dispositivo para guardar fotos o firmas. Sincronice y elimine registros subidos en Sync → Almacenamiento.';

/** Returns true when used/quota crosses {@link SYNC_STORAGE_QUOTA_WARN_RATIO}. */
export function shouldWarnStorageQuota(usedBytes: number, quotaBytes: number | null | undefined): boolean {
  if (quotaBytes == null || quotaBytes <= 0) return false;
  if (usedBytes <= 0) return false;
  return usedBytes / quotaBytes >= SYNC_STORAGE_QUOTA_WARN_RATIO;
}

/** Returns true when projected usage would cross {@link SYNC_STORAGE_QUOTA_BLOCK_RATIO}. */
export function shouldBlockStorageQuota(
  projectedUsedBytes: number,
  quotaBytes: number | null | undefined,
  blockRatio: number = SYNC_STORAGE_QUOTA_BLOCK_RATIO,
): boolean {
  if (quotaBytes == null || quotaBytes <= 0) return false;
  if (projectedUsedBytes <= 0) return false;
  return projectedUsedBytes / quotaBytes >= blockRatio;
}
